module.exports = __webpack_public_path__ + "static/media/creative-solutions-freelancer-hero-image.9e154db3.webp";